// src/App.js
import { Box, Container, Heading } from "@chakra-ui/react";
import Shyari from "./Component/ShayariCategory";
; // Import your Shayari category component

function App() {
  return (
      <Box bg="grey.100" minHeight="100vh">
        <Container maxW="xl" py="4">
        <Heading as="h1" size="xl" mb="4" textAlign="center" color="red" fontFamily="cursive" textShadow="2px 2px 4px rgba(0, 0, 0, 0.5)">
  <span style={{ display: 'block', fontSize: '1.2em', letterSpacing: '2px', fontWeight: 'bold', marginBottom: '10px' }}>⭐️ Welcome to ⭐️</span>
  AI Content Generator
</Heading>

        <Shyari/>
           
        </Container>
      </Box>
  );
}

export default App;
